/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Styled } from './index.styles';
import { SaveHotelProps } from '../../organisms/SearchResults/index.types';
import { useConditionalSavedPropertiesDispatchContextSERP } from '../../hooks/lib/useConditionalSavedPropertiesDispatchContext';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    // extends React's HTMLAttributes
    custom_click_track_value?: string;
  }
}

/** Default tracking value for SERP page usage */
const DEFAULT_CLICK_TRACK_VALUE = 'SERP page|Hotel Save|internal|event23';

export interface SaveHotelButtonProps extends SaveHotelProps {
  /** Custom click tracking value to override the default */
  clickTrackValue?: string;
}

export const SaveHotelButton: React.FC<SaveHotelButtonProps> = ({
  propertyID,
  clickTrackValue = DEFAULT_CLICK_TRACK_VALUE,
}) => {
  const { savedData, dispatch } = useConditionalSavedPropertiesDispatchContextSERP();

  const isSavedProperty = savedData?.savedPropertiesList?.find(
    (marsha: { id: string | undefined }) => marsha.id === propertyID
  );
  const [hotelSaved, setHotelSaved] = useState<boolean>(isSavedProperty ? true : false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const saveHotelClick = (event: any): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (!propertyID) {
        return; // Exit early if propertyID is undefined
      }

      if (isSavedProperty) {
        setHotelSaved(false);
        dispatch({
          type: 'removed',
          payload: propertyID,
        });
      } else {
        setHotelSaved(true);
        dispatch({
          type: 'added',
          payload: propertyID,
        });
      }
    }
  };

  return (
    <Styled>
      <div
        tabIndex={0}
        className="inverse icon-container custom_click_track"
        // onClick={saveHotelClick}
        // onKeyDown={saveHotelClick}
        onClick={(e): void => saveHotelClick(e)}
        onKeyDown={(e): void => saveHotelClick(e)}
        {...{ custom_click_track_value: clickTrackValue }}
        aria-label="Save hotel button"
        role="button"
      >
        <span className={`icon-heart-outline icon-inverse ` + (hotelSaved ? `hide-icon` : ``)} />
        <span className={`icon-heart-fill icon-inverse ` + (hotelSaved ? `` : `hide-icon`)} />
      </div>
    </Styled>
  );
};
